import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ReplayIcon from "@mui/icons-material/Replay";

import Boards from "../Filters/Boards";
import Epics from "../Filters/Epics";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useSetMultipleParams } from "../../../../hooks/useSetMultipleParams";
import { addAllBoard } from "../../../../redux/SearchSlice";
import clearFilterIcon from "../../../../styles/svg/clearFilterIcon.svg";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";
import { useRemoveMultipleParams } from "../../../../hooks/useRemoveMultipleParams";

function Filter({ setFilterDrawer }) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const reporter = searchParams.get("reporter");
  const [reporterValue, setReporterValue] = useState(reporter === "true");
  const [setMultipleSearchParams] = useSetMultipleParams();
  const [removeMultiParams] = useRemoveMultipleParams();
  const isMobile = useResponsive("down", "md");
  const [Oldboard, updateParams, removeSearchParam] =
    useCustomSearchParams("board");
  const [milestones] = useCustomSearchParams("milestone");
  const removeSearchParams = (paramsToRemove) => {
    const newSearchParams = new URLSearchParams(searchParams);

    paramsToRemove.forEach((param) => {
      newSearchParams.delete(param);
    });

    setSearchParams(newSearchParams);
  };

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  };

  const checkedList = useSelector((state) => state.search.boardSearch);
  const selectedEpic = useSelector((state) => state?.search?.epicSearch);

  const clearFilters = () => {
    removeSearchParams(["board", "milestone", "reporter"]);
    dispatch(addAllBoard([]));
  };

  const changeReporterSearch = (event) => {
    event.stopPropagation();
    setReporterValue(!reporterValue);
    if (!isMobile) {
      if (reporter == "true") {
        removeSearchParams(["reporter"]);
      } else {
        updateSearchParams("reporter", true);
      }
    }
  };

  const handleApplyFilter = () => {
    if (checkedList.length == 0 && Oldboard?.length > 0 && !reporterValue) {
      removeMultiParams(["board", "milestone", "reporter"]);
    } else if (checkedList?.length > 1 && selectedEpic.length == 0 && milestones?.length > 0 && !reporterValue) {
      removeSearchParams(["milestone", "reporter"]);
    } else if (selectedEpic.length > 0 && checkedList?.length == 1 && reporterValue) {
      setMultipleSearchParams([
        {
          name: "milestone",
          value: selectedEpic,
        },
        {
          name: "board",
          value: checkedList,
        },
        {
          name: "reporter",
          value: true,
        },

      ]);
    } else {
      if (reporterValue) {
        setMultipleSearchParams([
          {
            name: "board",
            value: checkedList,
          },
          {
            name: "reporter",
            value: true,
          },
        ]);
      } else {
        setMultipleSearchParams([
          {
            name: "milestone",
            value: selectedEpic,
          },
          {
            name: "board",
            value: checkedList,
          },
          {
            name: "reporter",
            value: false,
          }
        ]);
      }
    }
    setFilterDrawer();
  };
  return (
    <div className="d-flex align-items-center">
      {isMobile ? (
        <div className="width-100 height-100">
          <div className="filter-head-container">
            <p className="filter-head-mobile">Filter By</p>
            {(Oldboard || reporter) && (
              <div className="d-flex align-items-center" onClick={clearFilters}>
                <ReplayIcon className="reset-mobile-icon" />
                <p className="reset-text-mobile">Reset</p>
              </div>
            )}
          </div>
          <div className="filter-body-container">
            <CustomButton
              className="capitalize mt-2 include-created-by-me-btn"
              sx={{
                width: "100%",
              }}
              variant="outlined"
            >
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  checked={reporterValue}
                  onClick={changeReporterSearch}
                />
                <span class="checkmark"></span>
                Include created by me
              </label>
            </CustomButton>

            <Boards isAssignToMe={true} />
            {checkedList && checkedList.length == 1 && (
              <Epics isAssignToMe={true} />
            )}
            <div className="mt-4"></div>
            <CustomButton
              className=" capitalize mobile-board-filter-apply-btn"
              variant="outlined"
              onClick={handleApplyFilter}
            >
              Apply
            </CustomButton>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex align-items-center">
            {Oldboard && (
              <img
                src={clearFilterIcon}
                className="cursor-pointer"
                onClick={clearFilters}
                alt="clear filter"
              />
            )}
          </div>
          {checkedList && checkedList.length == 1 && (
            <Epics isAssignToMe={true} />
          )}
          <div className="mr-4">
            <Boards isAssignToMe={true} />
          </div>
          <CustomButton
            className="white-button capitalize board-filter-button"
            variant="outlined"
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                checked={reporterValue}
                onClick={changeReporterSearch}
              />
              <span class="checkmark"></span>
              Include created by me
            </label>
          </CustomButton>
        </>
      )}
    </div>
  );
}

export default Filter;
